import social_behance from './social-behance.svg';
import social_dribbble from './social-dribbble.svg';
import social_facebook from './social-facebook.svg';
import social_instagram from './social-instagram.svg';
import social_linkedin from './social-linkedin.svg';
import social_medium from './social-medium.svg';
import social_pinterest from './social-pinterest.svg';
import social_podcast from './social-podcast.svg';
import social_snapchat from './social-snapchat.svg';
import social_spotify from './social-spotify.svg';
import social_stack_overflow from './social-stack-overflow.svg';
import social_tumblr from './social-tumblr.svg';
import social_twitter from './social-twitter.svg';
import social_vimeo from './social-vimeo.svg';
import social_wordpress from './social-wordpress.svg';
import social_youtube from './social-youtube.svg';

export const V2_SOCIAL_ICONS: { [char: string]: string } = {
  social_behance,
  social_dribbble,
  social_facebook,
  social_instagram,
  social_linkedin,
  social_medium,
  social_pinterest,
  social_podcast,
  social_snapchat,
  social_spotify,
  social_stack_overflow,
  social_tumblr,
  social_twitter,
  social_vimeo,
  social_wordpress,
  social_youtube,
};

export const V2_SOCIAL_ICON_NAMES: string[] = Object.keys(V2_SOCIAL_ICONS);
